module.exports = __webpack_public_path__ + "img/pie-graph.b8a1ba95.svg";